import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-cover-laminated',
  templateUrl: './tooltip-info-cover-laminated.component.html',
  styleUrls: ['./tooltip-info-cover-laminated.component.scss'],
  standalone: false
})
export class TooltipInfoCoverLaminatedComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
